import {
  BlockWrapper,
  defineBlock,
  useEditor,
  useInspectorControl,
  smartProps,
} from "@smartfire/js-block-engine";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import style from "./style.module.scss";

const Inspector = React.lazy(() => import("./inspector.js"));

function Button({
  text,
  linkType,
  link,
  pageId,
  postId,
  categoryId,
  targetBlank = false,
  color = "",
  colorHover = "",
  hasBorder = false,
  borderColor = "",
  align,
  className = null,
  wrapper = true,
  showInspector = true,
  tagName = "a",
  isSubmit = false,
  fileId = null,
  withWrapper = false,
  onClick = () => {},
  ...props
}) {
  const { isEditing } = useEditor();
  useInspectorControl(showInspector ? Inspector : () => "");
  const Tag = tagName;
  // React i18next
  const { t } = useTranslation();

  const href = useMemo(() => {
    switch (linkType) {
      case "email":
        return "mailto:" + link;

      case "tel":
        return "tel:" + link;

      default:
        return link;
    }
  }, [link, linkType]);

  const Component = () => (
    <Tag
      className={clsx(className, style.button, hasBorder && style.withBorder)}
      href={!isEditing ? href : undefined}
      target={targetBlank ? "_blank" : undefined}
      download={linkType === "file"}
      type={isSubmit ? "submit" : null}
      style={{
        "--color": color,
        "--colorHover": colorHover,
        "--borderColor": borderColor,
      }}
      onClick={onClick}
      {...props}
    >
      <span className={style.text}>{text || t("Button text")}</span>
      {props.children}
    </Tag>
  );

  return (
    <BlockWrapper.Div>
      {wrapper ? (
        <div className={clsx(style.wrapper, align && style[align])}>
          <Component />
        </div>
      ) : (
        <Component />
      )}
    </BlockWrapper.Div>
  );
}

export default defineBlock({
  Block: Button,
  smartProps: {
    text: smartProps.string.withDefault(""),
    linkType: smartProps.string.withDefault("page"),
    link: smartProps.string.withDefault(""),
    pageId: smartProps.number.withDefault(0),
    postId: smartProps.number.withDefault(0),
    categoryId: smartProps.number.withDefault(0),
    fileId: smartProps.number.withDefault(0),
    targetBlank: smartProps.bool.withDefault(false),
    color: smartProps.string.withDefault(style.seasonColor),
    colorHover: smartProps.string.withDefault(style.seasonColorHover),
    hasBorder: smartProps.bool.withDefault(false),
    borderColor: smartProps.string.withDefault(style.seasonBorderColor),
    align: smartProps.string.withDefault("center"),
    withWrapper: smartProps.bool.withDefault(false),
  },
  setup: {
    title: "Button",
  },
});
